<template>
    <b-card
        no-body
    >
        <div
            class="card-body text-center"
        >
            <p>
                {{ $t('v4["There are (availablePeriod) days left to use. To extend, click the next button"]', { availablePeriod: availablePeriod }) }}
            </p>
            <div
            >
                <b-button
                    variant="warning"
                    @click="extendPeriod"
                >
                    <feather-icon
                        class="mr-25"
                        icon="CheckSquareIcon"
                    />
                    <span class="align-middle">
                        {{ $t('v4.Extension') }}
                    </span>
                </b-button>
            </div>
        </div>
    </b-card>
</template>

<script>
import { getCurrentInstance } from '@vue/composition-api'
import bus from '@/libs/bus'
export default {
    props: {
        availablePeriod: {
            type: Number
        }
    },
    setup (props, context) {
        const vm = getCurrentInstance().proxy
        const store = vm.$store
        const updatePeriodExtension = () => store.dispatch('$_open_api/updatePeriodExtension')
        const extendPeriod = () => {
            updatePeriodExtension().then(() => {
                const message = vm.$t('org.message.The usable period has been extended')
                bus.$emit('request:success', { title: 'SUCCESS', content: message })
                vm.$emit('alert:message', { status: 'success', message })
            }).catch(error => {
                if (error?.response?.data?.errorMessage) {
                    vm.$emit('alert:message', { status: 'danger', message: error.response.data.errorMessage })
                }
            })
        }
        return {
            extendPeriod
        }
    }
}
</script>

<style>

</style>
